const navbar = [
    {
        href: '/',
        label: 'Начало',
    },
    {
        href: '/about',
        label: 'За Нас',
    },
    {
        href: '/beforeafter',
        label: 'Преди и След',
    },
    {
        href: '',
        label: 'Услуги',
        submenu: {
            ['Ортодонтия']: [
                {
                    href: '/services/orthodontics',
                    label: 'Първичен ортодонтски преглед',
                },
                {
                    href: '/services/complete-diagnosis',
                    label: 'Пълен ортодонтски анализ',
                },
                {
                    href: '/services/children',
                    label: 'Ортодонтия за деца',
                },
                {
                    href: '/services/teens',
                    label: 'Ортодонтия за тийнейджъри',
                },
                {
                    href: '/services/adults',
                    label: 'Ортодонтия за възрастни',
                },
            ],
            ['Други услуги']: [
                {
                    href: '/services/implantology',
                    label: 'Имплантология',
                },
                {
                    href: '/services/aligners',
                    label: 'Лечение с прозрачни шини',
                },
                {
                    href: '/services/edm',
                    label: 'Естетична дентална медицина',
                },
            ],
        },
    },
    {
        href: '/contact',
        label: 'Контакти',
    },
];

const footer = {
    Меню: [
        {
            href: '/',
            label: 'Начало',
        },
        {
            href: '/about',
            label: 'За Нас',
        },
    ],
    Помощ: [
        {
            href: '/contact',
            label: 'Контакти',
        },
        {
            href: '/privacy-policy',
            label: 'Политика за поверителност',
        },
        {
            href: '/terms',
            label: 'Общи условия',
        },
    ],
};
export { navbar, footer };
